import pdfReport from './reducer';

export * from './reducer';
export default pdfReport;
